<script lang="ts">
  import { fade } from 'svelte/transition';
  import { Share2, Twitter, MessageCircle } from 'lucide-svelte';

  export let url: string;
  export let title: string = '';

  let isShareMenuOpen = false;

  const copyToClipboard = (text: string) => {
      navigator.clipboard.writeText(text);
      // TODO: トースト通知を実装
  };

  const shareToTwitter = () => {
      const encodedUrl = encodeURIComponent(`vt-grid.com${url}`);
      const encodedText = encodeURIComponent(title);
      window.open(`https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedText}`, '_blank');
  };

  const shareToLINE = () => {
      const encodedUrl = encodeURIComponent(`vt-grid.com${url}`);
      window.open(`https://line.me/R/msg/text/?${encodedUrl}`, '_blank');
  };
</script>

<div class="relative">
  <button 
      on:click={() => isShareMenuOpen = !isShareMenuOpen}
      class="flex items-center gap-1.5 px-2.5 h-7 rounded-md text-neutral-500 hover:text-neutral-900 hover:bg-neutral-50 dark:text-neutral-400 dark:hover:text-white dark:hover:bg-neutral-800 transition-all"
  >
      <Share2 size={14} />
      <span class="text-xs font-medium">シェア</span>
  </button>

  {#if isShareMenuOpen}
      <div 
          class="absolute z-10 top-full right-0 mt-1 w-80 p-3 bg-white dark:bg-neutral-900 rounded-lg shadow-lg border border-neutral-200 dark:border-neutral-800"
          transition:fade={{ duration: 100 }}
      >
          <div class="space-y-3">
              <!-- URL共有 -->
              <div>
                  <div class="text-xs font-medium text-neutral-500 dark:text-neutral-400 mb-1.5">動画URL</div>
                  <div class="flex gap-2">
                      <input 
                          type="text" 
                          readonly 
                          value={`vt-grid.com${url}`}
                          class="flex-1 text-sm px-2 h-8 rounded bg-neutral-100 dark:bg-neutral-800 text-neutral-900 dark:text-white border border-neutral-200 dark:border-neutral-700"
                      />
                      <button 
                          class="whitespace-nowrap px-3 h-8 rounded bg-neutral-100 hover:bg-neutral-200 dark:bg-neutral-800 dark:hover:bg-neutral-700 text-neutral-900 dark:text-white text-sm font-medium transition-colors"
                          on:click={() => copyToClipboard(`vt-grid.com${url}`)}
                      >
                          コピー
                      </button>
                  </div>
              </div>

              <!-- SNSシェア -->
              <div class="flex gap-2 pt-2 border-t border-neutral-200 dark:border-neutral-700">
                  <button 
                      class="flex-1 flex items-center justify-center gap-1.5 h-8 rounded bg-neutral-100 hover:bg-neutral-200 dark:bg-neutral-800 dark:hover:bg-neutral-700 text-neutral-900 dark:text-white text-sm font-medium transition-colors"
                      on:click={shareToTwitter}
                  >
                      <Twitter size={14} />
                      <span>Twitter</span>
                  </button>
                  <button 
                      class="flex-1 flex items-center justify-center gap-1.5 h-8 rounded bg-neutral-100 hover:bg-neutral-200 dark:bg-neutral-800 dark:hover:bg-neutral-700 text-neutral-900 dark:text-white text-sm font-medium transition-colors"
                      on:click={shareToLINE}
                  >
                      <MessageCircle size={14} />
                      <span>LINE</span>
                  </button>
              </div>
          </div>
      </div>
  {/if}
</div> 